// AdminProfile.jsx - Estate Experts Admin Profile
import React, { useContext, useEffect, useState } from 'react';
import {
  FiEdit2,
  FiSave,
  FiX,
  FiUser,
  FiMail,
  FiPhone,
  FiMapPin,
  FiCamera,
  FiCheck,
  FiBell,
  FiChevronRight
} from 'react-icons/fi';
import '../../../assets/css/admin/dashboard/adminprofile/adminprofile.css';
import AdminMasterLayout from 'layouts/AdminMasterLayout';
import { FaEye, FaEyeSlash, FaLock, FaSave, FaTimes } from 'react-icons/fa';
import axios from 'axios';
import AppContext from 'context/AppContext';


const AdminProfile = () => {
  const { baseUrl, loggedInAdmin, authToken } = useContext(AppContext);
  const [profileData, setProfileData] = useState({});
  const updateProfile = () => {
    const formData = new FormData();

    formData.append("id", loggedInAdmin.id);
    formData.append("fullName", tempData.fullName || "");
    formData.append("email", tempData.email || "");
    formData.append("phone", tempData.phone || "");

    axios.post(
      `${baseUrl}/admin/profile/updateProfile`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
      .then((response) => {
        console.log(response.data);

        if (response.data.success) {
          setEditingSections(prev => ({
            ...prev,
            personal: false
          }));

          setShowSuccess(true);

          setTimeout(() => {
            setShowSuccess(false);
          }, 3000);
        }
      })
      .catch((error) => {
        console.log(error.response?.data || error);
      });
  };
  const [editingSections, setEditingSections] = useState({
    personal: false,
    business: false,
    // account: false
  });

  const [tempData, setTempData] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);

  // Password visibility states
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  // Password form data
  const [passwordData, setPasswordData] = useState({
    // currentPassword: '',
    // newPassword: '',
    // confirmPassword: ''
  });

  const changePassword = () => {
    const formData = new FormData();
    formData.append("currentPassword", passwordData.currentPassword);
    formData.append("newPassword", passwordData.newPassword);
    formData.append("confirmPassword", passwordData.confirmPassword);
    axios
      .post(`${baseUrl}/admin/auth/changePassword`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${authToken}`
        },
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.success) {
          alert(response.data.message);
          closePasswordModal();
          setPasswordData({
            currentPassword: "",
            newPassword: "",
            confirmPassword: ""
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });

  };

  // const handleEdit = (section) => {
  //   setEditingSections(prev => ({ ...prev, [section]: true }));
  //   setTempData(profileData);
  // };

  const handleCancel = (section) => {
    setEditingSections(prev => ({ ...prev, [section]: false }));
    setTempData({});
  };

  const handleSave = (section) => {
    setProfileData(tempData);
    setEditingSections(prev => ({ ...prev, [section]: false }));
    setShowSuccess(true);

    setTimeout(() => {
      setShowSuccess(false);
    }, 3000);
  };

  const handleChange = (field, value) => {
    setTempData(prev => ({ ...prev, [field]: value }));
  };

  const openPasswordModal = () => {
    setIsPasswordModalOpen(true);
    setPasswordData({
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    });
  };

  const closePasswordModal = () => {
    setIsPasswordModalOpen(false);
    setPasswordData({
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    });
    setShowCurrentPassword(false);
    setShowNewPassword(false);
    setShowConfirmPassword(false);
  };

  const handlePasswordChange = (field, value) => {
    setPasswordData({
      ...passwordData,
      [field]: value
    });
  };

  // Notification Settings State
  const [notificationSettings, setNotificationSettings] = useState({
    desktopNotifications: true,
    emailNotifications: true,
    activityEmail: 'example@estateexperts.com',
    sendActivitySummary: 'Daily',
    bookingReminders: '1st mins, 30 min: 1 hours',
    automaticReportSettings: 'Monthly'
  });
  // Security Settings State
  const [securitySettings, setSecuritySettings] = useState({
    twoFactorAuth: false,
    devices: [
      { id: 1, name: 'MacBook Pro', location: 'Karachi, Pakistan', lastActive: '2 mins ago', current: true },
      { id: 2, name: 'iPhone 14', location: 'Lahore, Pakistan', lastActive: '1 hour ago', current: false }
    ]
  });
  // Appearance Settings State
  const [appearanceSettings, setAppearanceSettings] = useState({
    mode: 'Light',
    reduceMotion: false,
    startOfWeek: 'Sunday',
    hoursToShow: 12
  });

  const handleToggle = (section, key) => {
    if (section === 'notification') {
      setNotificationSettings(prev => ({
        ...prev,
        [key]: !prev[key]
      }));
    } else if (section === 'security') {
      setSecuritySettings(prev => ({
        ...prev,
        [key]: !prev[key]
      }));
    } else if (section === 'appearance') {
      setAppearanceSettings(prev => ({
        ...prev,
        [key]: !prev[key]
      }));
    }
  };


  const displayData = (section) => {
    return editingSections[section] ? tempData : profileData;
  };
  // const handlePasswordSubmit = () => {
  //   // Validation
  //   if (!passwordData.currentPassword || !passwordData.newPassword || !passwordData.confirmPassword) {
  //     alert('Please fill all password fields');
  //     return;
  //   }

  //   if (passwordData.newPassword !== passwordData.confirmPassword) {
  //     alert('New password and confirm password do not match');
  //     return;
  //   }

  //   if (passwordData.newPassword.length < 8) {
  //     alert('Password must be at least 8 characters long');
  //     return;
  //   }

  //   // Save password (in real app, this would call an API)
  //   console.log('Password changed successfully');
  //   closePasswordModal();
  //   showSuccess('Password changed successfully!');
  // };

  return (
    <AdminMasterLayout pageTitle='Admin Profile'>
      <div className="admin-profile-page">
        {/* Success Toast */}
        {showSuccess && (
          <div className="adminprofile-success-toast">
            <FiCheck className="adminprofile-toast-icon" />
            <span>Profile updated successfully!</span>
          </div>
        )}

        {/* Page Header */}
        {/* <div className="profile-page-header">
          <div>
            <h1 className="adminprofile-page-title">Admin Profile</h1>
            <p className="adminprofile-page-subtitle">Review and update your admin profile information</p>
          </div>
        </div> */}

        {/* Profile Header Card */}
        <div className="adminprofile-header-card">
          <div className="adminprofile-avatar-section">
            {/* <div className="adminprofile-avatar-wrapper">
            <img 
              src={loggedInAdmin.avatar} 
              alt="Profile" 
              className="adminprofile-avatar"
            />
            <label className="adminprofile-avatar-upload-btn">
              <FiCamera />
              <input 
                type="file" 
                accept="image/*"
                onChange={handleAvatarChange}
                style={{ display: 'none' }}
              />
            </label>
          </div> */}
            <div className="adminprofile-header-info">
              <h2 className="adminprofile-name">{loggedInAdmin?.fullName}</h2>
              <p className="adminprofile-role">{loggedInAdmin?.role}</p>
              <p className="adminprofile-location">
                <FiPhone size={16} />
                {loggedInAdmin?.phone}
              </p>
            </div>
          </div>
          {/* Change Password Button */}
          <button
            className="adminprofile-change-password-btn"
            onClick={openPasswordModal}
          >
            <FaLock /> Change Password
          </button>
          {/* <button className="adminprofile-edit-profile-btn">
          <FiEdit2 size={18} />
          Edit Profile
        </button> */}
        </div>

        {/* Personal Information */}
        <div className="adminprofile-section-card">
          <div className="adminprofile-section-header">
            <h3 className="adminprofile-section-title">Personal Information</h3>
            {!editingSections.personal ? (
              <button
                className="adminprofile-edit-btn"
                onClick={() => {
                  setTempData({
                    fullName: loggedInAdmin?.fullName || "",
                    email: loggedInAdmin?.email || "",
                    phone: loggedInAdmin?.phone || "",
                  });

                  setEditingSections(prev => ({
                    ...prev,
                    personal: true
                  }));
                }}
              >
                <FiEdit2 size={16} />
                Edit
              </button>
            ) : (
              <div className="adminprofile-edit-actions">
                <button
                  className="adminprofile-cancel-btn"
                  onClick={() => handleCancel('personal')}
                >
                  <FiX size={16} />
                  Cancel
                </button>
                <button
                  className="adminprofile-save-btn"
                  onClick={updateProfile}
                >
                  <FiSave size={16} />
                  Save
                </button>
              </div>
            )}
          </div>

          <div className="adminprofile-section-content">
            <div className="adminprofile-info-grid">
              <div className="adminprofile-info-item">
                <label className="adminprofile-info-label">Full Name</label>
                {editingSections.personal ? (
                  <input
                    type="text"
                    value={displayData('personal')?.fullName || ""}
                    onChange={(e) => handleChange('fullName', e.target.value)}
                    className="adminprofile-info-input"
                  />
                ) : (
                  <p className="adminprofile-info-value">{loggedInAdmin?.fullName}</p>
                )}
              </div>

              {/* <div className="adminprofile-info-item">
                <label className="adminprofile-info-label">Location</label>
                {editingSections.personal ? (
                  <input
                    type="text"
                    // value={displayData('personal').location}
                    value={loggedInAdmin?.location || ""}
                    onChange={(event) => {
                      setLocation(event.target.value)
                    }}
                    className="adminprofile-info-input"
                  />
                ) : (
                  <p className="adminprofile-info-value">{loggedInAdmin?.location}</p>
                )}
              </div> */}

              <div className="adminprofile-info-item">
                <label className="adminprofile-info-label">Email Address</label>
                {editingSections.personal ? (
                  <input
                    type="email"
                    value={displayData('personal')?.email}
                    onChange={(e) => handleChange('email', e.target.value)}
                    className="adminprofile-info-input"
                  />
                ) : (
                  <p className="adminprofile-info-value">{loggedInAdmin?.email}</p>
                )}
              </div>

              <div className="adminprofile-info-item">
                <label className="adminprofile-info-label">Phone</label>
                {editingSections.personal ? (
                  <input
                    type="tel"
                    value={displayData('personal').phone}
                    // value={displayData('personal')?.phone || ""}
                    onChange={(event) => {
                      handleChange('phone',event.target.value)
                    }}
                    className="adminprofile-info-input"
                  />
                ) : (
                  <p className="adminprofile-info-value">{loggedInAdmin?.phone}</p>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* <div className="settings-card slide-up" style={{ animationDelay: '0.1s' }}>
          <div className="card-header-section">
            <div className="header-icon-wrapper">
              <div className="header-icon notification">
                <FiBell />
              </div>
              <div className="header-text">
                <h3 className="card-title">Notification Settings</h3>
                <p className="card-subtitle">Settings | preferences</p>
              </div>
            </div>
            <FiChevronRight className="chevron-icon" />
          </div>

          <div className="settings-list">
            <div className="setting-item">
              <div className="setting-label">
                <span>In app Notifications</span>
              </div>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={notificationSettings.desktopNotifications}
                  onChange={() => handleToggle('notification', 'desktopNotifications')}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>

            <div className="setting-item">
              <div className="setting-label">
                {/* <FiMail className="setting-icon" /> 
                <span>Email Notifications</span>
              </div>
              <label className="toggle-switch">
                <input
                  type="checkbox"
                  checked={notificationSettings?.emailNotifications}
                  onChange={() => handleToggle('notification', 'emailNotifications')}
                />
                <span className="toggle-slider"></span>
              </label>
            </div>


          </div>
        </div> */}
        {/* ==========================================
                    CHANGE PASSWORD MODAL
                    ========================================== */}
        {isPasswordModalOpen && (
          <div className="adminprofile-modal-overlay" onClick={closePasswordModal}>
            <div className="adminprofile-modal" onClick={(e) => e.stopPropagation()}>

              {/* Modal Header */}
              <div className="adminprofile-modal-header">
                <h3 className="adminprofile-modal-title">
                  <FaLock /> Change Password
                </h3>
                <button
                  className="adminprofile-modal-close-btn"
                  onClick={closePasswordModal}
                >
                  <FaTimes />
                </button>
              </div>

              {/* Modal Body */}
              <div className="adminprofile-modal-body">
                <form className="adminprofile-password-form" onSubmit={(e) => e.preventDefault()}>

                  {/* Current Password */}
                  <div className="adminprofile-password-group">
                    <label className="adminprofile-password-label">Current Password</label>
                    <div className="adminprofile-password-input-wrapper">
                      <input
                        type={showCurrentPassword ? "text" : "password"}
                        className="adminprofile-password-input"
                        value={passwordData.currentPassword}
                        onChange={(e) => handlePasswordChange('currentPassword', e.target.value)}
                        placeholder="Enter current password"
                      />
                      <button
                        type="button"
                        className="adminprofile-password-toggle"
                        onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                      >
                        {showCurrentPassword ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                  </div>

                  {/* New Password */}
                  <div className="adminprofile-password-group">
                    <label className="adminprofile-password-label">New Password</label>
                    <div className="adminprofile-password-input-wrapper">
                      <input
                        type={showNewPassword ? "text" : "password"}
                        className="adminprofile-password-input"
                        value={passwordData.newPassword}
                        onChange={(e) => handlePasswordChange('newPassword', e.target.value)}
                        placeholder="Enter new password"
                      />
                      <button
                        type="button"
                        className="adminprofile-password-toggle"
                        onClick={() => setShowNewPassword(!showNewPassword)}
                      >
                        {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                  </div>

                  {/* Confirm Password */}
                  <div className="adminprofile-password-group">
                    <label className="adminprofile-password-label">Confirm Password</label>
                    <div className="adminprofile-password-input-wrapper">
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        className="adminprofile-password-input"
                        value={passwordData.confirmPassword}
                        onChange={(e) => handlePasswordChange('confirmPassword', e.target.value)}
                        placeholder="Confirm new password"
                      />
                      <button
                        type="button"
                        className="adminprofile-password-toggle"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      >
                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                      </button>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="adminprofile-modal-actions">
                    <button
                      type="button"
                      className="adminprofile-modal-cancel-btn"
                      onClick={closePasswordModal}
                    >
                      <FaTimes /> Cancel
                    </button>
                    <button
                      type="button"
                      className="adminprofile-modal-save-btn"
                      onClick={changePassword}
                    >
                      <FaSave /> Save Password
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </AdminMasterLayout>
  );
};

export default AdminProfile;